import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
            探索内容分类
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto leading-relaxed">
            按照你感兴趣的领域浏览，找到最适合你的科普内容
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 rounded-xl bg-background-50 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1">
                {cat.articleCount} 篇
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}